import { getTrans } from '@/services/global/translations.interface';
import tectoastr from '@/lib/tectoastr';
import { ClipboardPipeline, Plugin, UpcastWriter } from 'ckeditor5';
import type { EditingView, EventInfo, ViewElement } from 'ckeditor5';

declare module '@ckeditor/ckeditor5-core' {
	// eslint-disable-next-line no-unused-vars
	interface PluginsMap {
		[ClipboardBlockImagePaste.pluginName]: ClipboardBlockImagePaste;
	}
}

class ClipboardBlockImagePaste extends Plugin {
	public static get pluginName() {
		return 'ClipboardBlockImagePaste ' as const;
	}

	public init() {
		const { editor } = this;
		const clipboard = editor.plugins.get('ClipboardPipeline') as ClipboardPipeline;
		const view = editor.editing.view;

		clipboard.on('inputTransformation', this.handler(view));
	}

	private handler(view: EditingView) {
		return (evt: EventInfo<string, unknown>, data: { content: ViewElement }) => {
			const writer = new UpcastWriter(view.document);
			const toRemove: ViewElement[] = [];

			// Gather and store base64 images in an array
			for (const { item } of view.createRangeIn(data.content)) {
				if (!item.is?.('element', 'img')) continue;

				toRemove.push(item as ViewElement);
			}

			if (!toRemove.length) return;

			// Remove them in the end to avoid mutating the dom until all images are identified
			toRemove.forEach((node) => writer.remove(node.parent?.name === 'figure' ? node.parent : node));
			tectoastr.error(getTrans().get('editor.pasting_images_is_not_supported'));
		};
	}
}

export default ClipboardBlockImagePaste;
